export default __webpack_public_path__ + "static/media/ozowLogo@2x.6566df80.png";